const displayName = 'Events'
const appName     = 'events'

export { displayName, appName }
